import script from "./Filelist.vue?vue&type=script&lang=ts&setup=true"
export * from "./Filelist.vue?vue&type=script&lang=ts&setup=true"

import "./Filelist.vue?vue&type=style&index=0&id=ab3cbf16&scoped=true&lang=scss"

import exportComponent from "/var/build/production/buyers-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab3cbf16"]])

export default __exports__